import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        toast.error("Sessione Google non trovata");
        nav("/auth", { replace: true });
        return;
      }
      try {
        const user = await googleLogin(sessionId);
        // Clear the hash so it doesn't linger in URL
        window.history.replaceState({}, document.title, "/dashboard");
        toast.success(`Bentornata, ${user.full_name?.split(" ")[0] || ""}!`);
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Accesso Google fallito");
        nav("/auth", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-canvas grid place-items-center px-6">
      <div className="text-center">
        <Logo size="lg"/>
        <div className="mt-8 flex items-center justify-center gap-3 text-stone">
          <div className="w-5 h-5 border-2 border-olive border-t-transparent rounded-full animate-spin"/>
          <span className="text-sm">Accesso Google in corso…</span>
        </div>
      </div>
    </div>
  );
}
